import '../../resources/css/visual/ModalVisualMonitorDetail.scss';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import VisualManagerForm from './VisualManagerForm';
import { openModal, closeModal, popupModalConfirm, openModalAlert } from '../../actions/index';
import VisualManagerList from './VisualManagerList';
import { doDeleteVisualData } from '../../actions/visual/index';
import { checkTableAuth } from '../common/access-auth';


// import moment from 'moment';
// import { closeMapModal, forwardMapList } from '../../actions/visual/index';
// import IpsAttackMapList from './IpsAttackMapList';

let optionValues = [];
class ModalVisualManagerDetail extends Component {
    constructor(props) {
        super(props);

        // this.backMapList = this.backMapList.bind(this);
        // this.closeModal = this.closeModal.bind(this);
        // this.updateShow = this.updateShow.bind(this);

        this.state = {
            show: false
        }
    }



    handleDelete(){
        const { popupModalConfirm, authToken, accountRole, roleTableAuth, openModalAlert, doDeleteVisualData, managerDetailData, closeModal } = this.props;
        
        if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
            const delGuardData = {
                id: managerDetailData.id
              }
            popupModalConfirm('Delete', 'icon-ico-failed', 'Confirm to delete?', 300, () => {doDeleteVisualData(delGuardData, authToken)}, null, false);
            closeModal(null);
        } else {
            openModalAlert("Sorry, you don't have permission to change config.");
        }
    }

    componentDidMount() {
    }
      
    componentDidUpdate (prevProps, prevState, snapshot) {  
    }

    render() {
        const { modalStatus, modalMessage, closeModal, openModal } = this.props;
        let show = modalStatus === 'visualManager', renderContent;
        let showSetting = modalStatus === 'visualManagerSetting';
        let showImportPDF = modalStatus === 'visualMangerImportPDF';

        if (show) {
            renderContent = (
                <Modal
                    show={show}
                    dialogClassName='modal-visual-manager-detail'
                    centered
                    onHide={() => closeModal(null)}
                >
                    <Modal.Body>
                        {/* <Row>
                            <Col sm={12} > */}
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6} className='area-modal-title'>
                                <span className='icon-rf-map-white'></span><label>{modalMessage === 'upd' ? 'Edit Floor Plan' : modalMessage === 'add-multi-floor' ? 'Add Floor Plan' : 'Floor Plan Info'}</label>
                                    {/* <div className={ modalType === 'list' ? 'area-label' : 'area-label no-display'}>
                                        <label>From : { displayFrom }</label>
                                    </div>
                                    <div className={ modalType === 'detail' ? 'area-back-icon' : 'area-back-icon no-display'}>
                                        <span className='icon-back-detail' onClick={this.backMapList}></span>
                                    </div> */}
                                </Col>
                                <Col sm={6} className='area-close-btn'>
                                    {modalMessage === 'view' ? <><span id="floor-plan-manager-edit" className='icon-btn-edit-white-n' onClick={() => {closeModal(null); openModal("visualManager", 'upd', null, null)}}></span>
                                <span id="floor-plan-manager-delete" className='icon-btn-delete-white-n' onClick={() => this.handleDelete() }></span>
                                     </> : ''}
                                    <span id="floor-plan-manager-close" className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                                {/* <Col sm={4} className='area-modal-time-range'>
                                    <div className={ modalType === 'list' ? 'area-label' : 'area-label no-display'}>
                                        <label>{ titleTimeRange }</label>
                                    </div>
                                    <div className={ modalType === 'detail' ? 'area-threat-icon' : 'area-threat-icon no-display'}>
                                        <span className='icon-threat-small'></span>
                                    </div>
                                </Col> */}
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            <VisualManagerForm groupList={optionValues}></VisualManagerForm>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        }
        else if (showImportPDF) {
            renderContent = (
                <Modal
                    show={showImportPDF}
                    dialogClassName='modal-visual-manager-detail'
                    centered
                    onHide={() => closeModal(showImportPDF, modalMessage)}
                >
                    <Modal.Body>
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6} className='area-modal-title'>
                                    <span className='icon-rf-map-white'></span><label>Import Floor Plan</label>
                                </Col>

                                <Col sm={6} className='area-close-btn'>
                                    <span className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>

                        <div className='area-modal-detail-content'>
                            <VisualManagerForm groupList={optionValues}></VisualManagerForm>
                        </div>

                    </Modal.Body>
                </Modal>
            )
        }
        else if (showSetting) {
            renderContent = (
                <Modal
                    show={showSetting}
                    dialogClassName='modal-visual-manager-detail-list'
                    centered
                    onHide={() => closeModal(null)}
                >
                    <Modal.Body>
                        {/* <Row>
                            <Col sm={12} > */}
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6} className='area-modal-title'>
                                <label>{modalMessage === 'setting' ? 'Floor Plan Manager' : null}</label>
                                    {/* <div className={ modalType === 'list' ? 'area-label' : 'area-label no-display'}>
                                        <label>From : { displayFrom }</label>
                                    </div>
                                    <div className={ modalType === 'detail' ? 'area-back-icon' : 'area-back-icon no-display'}>
                                        <span className='icon-back-detail' onClick={this.backMapList}></span>
                                    </div> */}
                                </Col>
                                <Col sm={1} className='area-close-btn'>
                                    <span id="floor-plan-manager-close" className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                                {/* <Col sm={4} className='area-modal-time-range'>
                                    <div className={ modalType === 'list' ? 'area-label' : 'area-label no-display'}>
                                        <label>{ titleTimeRange }</label>
                                    </div>
                                    <div className={ modalType === 'detail' ? 'area-threat-icon' : 'area-threat-icon no-display'}>
                                        <span className='icon-threat-small'></span>
                                    </div>
                                </Col> */}
                            </Row>
                        </div>
                        <div className='area-modal-detail-content-list'>
                            <VisualManagerList></VisualManagerList>
                        </div>
                            {/* </Col>
                        </Row> */}
                        {/* <Row>
                            <Col sm={12}>
                                <div className={ modalType === 'list' ? 'area-map-list' : 'area-map-list no-display' }>
                                    <IpsAttackMapList/>
                                </div>
                                <div className={ modalType === 'detail' ? 'area-map-detail' : 'area-map-detail no-display' }>
                                    <IpsAttackMapDetail/>
                                </div> 
                            </Col>
                        </Row> */}
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='modal-visual-manager-detail'>
                {renderContent}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    // const mapModal = state.visualReducers.mapModal;

    return {
        modalStatus: state.commonReducers.modalStatus,
        modalMessage: state.commonReducers.modalMessage,
        authToken: state.loginReducers.authToken,
        selectSite: state.siteReducers.selectSite,
        status: state.visualReducers.status,
        managerDetailData: state.visualReducers.managerDetailData,
        accountRole: state.loginReducers.accountRole,
        roleTableAuth: state.loginReducers.roleTableAuth,
    }
}

export default connect(
    mapStateToProps,
    { openModal, closeModal, popupModalConfirm, doDeleteVisualData, openModalAlert }
)(ModalVisualManagerDetail)